import { useMutation } from '@tanstack/react-query'

import { queryClient } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function useSendInsurancePartnerInvite(patientId) {
  return useMutation({
    mutationFn: () => API.patients.id(patientId).insurancePartners.invite(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QK.patients.id(patientId).insurances.summary }),
  })
}

export function useSetInsurancePartnerContacted(patientId) {
  return useMutation({
    mutationFn: () => API.patients.id(patientId).insurancePartners.update({ date_type: 'contacted' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QK.patients.id(patientId).insurances.summary }),
  })
}

export function useSetInsurancePartnerInsured(patientId) {
  return useMutation({
    mutationFn: () => API.patients.id(patientId).insurancePartners.update({ date_type: 'insured' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QK.patients.id(patientId).insurances.summary }),
  })
}
